import { align } from './align';
import { animatedHeight } from './animated-height';
import { border, borderAsCSS } from './border';
import { padding, spacer } from './spacer';
import { typeSpec } from './type-spec';
export const CFMixins = {
    align,
    animatedHeight,
    border,
    borderAsCSS,
    padding,
    spacer,
    typeSpec,
};
